import { render, staticRenderFns } from "./driverprofile.vue?vue&type=template&id=68bf92f6&scoped=true"
import script from "./driverprofile.js?vue&type=script&lang=js&external"
export * from "./driverprofile.js?vue&type=script&lang=js&external"
import style0 from "./driverprofile.vue?vue&type=style&index=0&id=68bf92f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf92f6",
  null
  
)

export default component.exports